export function Education() {
  return (
    <div>
      <h2 className="font-extrabold">EDUCATION</h2>
      <ul className="mt-4 flex flex-col flex-cols-1 text-slate-400 space-y-10">
        <li>
          <p className="text-xs font-extrabold text-slate-500">
            SEP 2020 - JUL 2025
          </p>
          <h3>
            <a
              href="https://www.leeds.ac.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-slate-200 hover:text-slate-300 font-semibold"
            >
              University of Leeds
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            MENG, BSC COMPUTER SCIENCE (INDUSTRIAL)
          </h4>
          <p className="text-sm mt-3">
            Achieved First Class Honours with 78% average. Won the MEng Group
            Project Prize. First Class Bachelors Dissertation on NFV and Network
            Slicing; First Class Masters Dissertation on Deep Learning and
            Augmented Reality in Liver Laparoscopy.
          </p>
        </li>

        <li>
          <p className="text-xs font-extrabold text-slate-500">
            SEP 2012 - JUL 2019
          </p>
          <h3>
            <a
              href="https://www.adamsgs.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-slate-200 hover:text-slate-300 font-semibold"
            >
              Haberdashers' Adams
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            GCSE & A LEVEL STUDENT
          </h4>
          <p className="text-sm mt-3">
            Achieved 10 GCSEs at A*/A (or equivalent), as well as A*AB in
            Mathematics, Computer Science and French respectively. Achieveded an
            A in AS Further Mathematics and completed an EPQ on the theoretical
            limits of Artificial Intelligence.
          </p>
        </li>
      </ul>
    </div>
  );
}
